import { Chatbot } from 'features/chatbot'
import React from 'react'
import styled from 'styled-components'

const SidebarContainer = styled.div`
  width: 400px;
  height: 100%;
  background-color: ${({ theme }) => theme.forecast.pageBackground1};
`

export const ChatbotSidebar: React.FC<{ onClose: () => void }> = ({
  onClose,
}) => {
  return (
    <SidebarContainer>
      <Chatbot onClose={onClose} />
    </SidebarContainer>
  )
}
